import {get_gallery_data} from "init/image_gallery"
import React from "react"
import {createRoot} from "react-dom/client"
import CombinedImageGallery from
  "components/image_gallery/combined_image_gallery"
import $ from "cash-dom"

const init_combined_image_gallery = (manager) => (
  get_image_data(manager).then((images) => {
    createRoot(manager).render(
      <CombinedImageGallery
        galleries={
          Array.from($(manager).find(".image-gallery-tab"))
            .map((gallery, index) => (
              {
                images: images[index],
                title: $(gallery).find(".image-gallery-tab__header").text(),
                is_open: !!$(gallery).find(".image-gallery").length
              }
            ))
        }
      />
    )
  })
)

function get_image_data(manager) {
  const image_slugs = JSON.parse(manager.dataset.imageSlugs)
  return Promise.all(
    image_slugs.map(slugs => get_gallery_data(slugs.split(",")))
  )
}

export default init_combined_image_gallery
